import { Component } from "react";

export default class PageHandler {
  constructor(pageName, component) {
    this.rootStore = null; // will be initialized by addPageHandlers

    if (!component instanceof Component) {
      throw new Error("component should be of type React.Component");
    }

    this.pageName = pageName;
    this.component = component;
  }
}


// WEBPACK FOOTER //
// ./src/Stores/UIStore/PageHandlers/PageHandler.js